import { baseEmailAssets, baseEmailTheme, TenantInfo } from '../common';
import { tos } from './tos';

export const tenant = {
  id: 'pace',
  name: 'Pace Global Logistics',
  isSystemTenant: false,
  domains: [
    'pace.tenant.pelicargo.dev',
    'pace.localhost',
    'pace.demo.pelicargo.dev',
    'airrate.com',
    'pace.demo.pelicargo.com',
  ],
  customerTheme: {
    colors: {
      primary: {
        '50': '#E9F3FB',
        '100': '#DEECFA',
        '200': '#BBD9F5',
        '300': '#80BAF0',
        '400': '#2A8EEC',
        '500': '#085399',
        '600': '#074E91',
        '700': '#044079',
        '800': '#01294F',
        '900': '#000810',
      },
    },
    logoDims: {
      height: 30,
      width: 130,
    },
    fullLogoDims: {
      height: 50,
      width: 180,
    },
  },
  emailTheme: {
    ...baseEmailTheme,
    primary: '#2A8EEC',
  },
  emailAssets: {
    ...baseEmailAssets,
    'logo-dark': 'https://raw.githubusercontent.com/pelicargo/assets/refs/heads/master/tenants/pace/pace_logo_dark.svg',
    'logo-dark-tagline':
      'https://raw.githubusercontent.com/pelicargo/assets/refs/heads/master/tenants/pace/pace_logo_tagline.svg',
    'logo-light':
      'https://raw.githubusercontent.com/pelicargo/assets/refs/heads/master/tenants/pace/pace_logo_light.svg',
    'logo-light-tagline':
      'https://raw.githubusercontent.com/pelicargo/assets/refs/heads/master/tenants/pace/pace_logo_tagline.svg',
    twitterUrl: 'https://to-be-determined/',
    facebookUrl: 'https://to-be-determined/',
    linkedinUrl: 'https://to-be-determined/',
    siteUrl: 'https://pacegloballogistics.com/',
    logo: 'https://raw.githubusercontent.com/pelicargo/assets/refs/heads/master/tenants/pace/logo.png',
  },
  admin: {
    cruds: {
      accounts: true,
      providers: false,
      airports: false,
      contacts: true,
      instructions: false,
      users: true,
      backlogs: false,
      surcharges: false,
      rates: false,
      'route-editor': false,
      configuration: false,
    },
    inbox: {
      requestDrawers: {
        // Provider Facing
        ProviderQuoting: false,
        AirlineBooking: false,
        RequestSchedule: false,
        BookingChange: false,
        BookingCancel: false,

        // Customer Facing
        QuoteUpdate: true,
        BookingConfirmation: true,
        NewRate: true,
        RequestClarifications: true,
        Contact: true,
        GenericEmailToFF: true,
        StatusUpdate: true,
      },
    },
    features: {
      instructionCreation: false,
    },
  },
  accountTypes: {
    IAC: false,
    IATA: false,
    ORGANIZATION: false,
    UNCERTIFIED: true,
  },
  termsOfService: tos,
  // helpUrl: 'https://docs.google.com/document/d/1CPAqKNH8qkimkl9ONXIB-8Lh-n9VbJTe9diBDWWqsW4/edit?usp=drive_link', // this is LMJ's
  helpUrl: '',
} as const satisfies TenantInfo<'pace'>;
